<template>
  <div class="opera-meeting">
    <topNav :title="$t('meetingOrder_title')"></topNav>
    <div class="ordertop">
      <div class="search">
        <i class="iconfont icon-sousuo"></i>
        <input type="text" id='seachContent' v-model='searchOption.searchText' name="" :placeholder="$t('meetingOrder_seachContent_placeholder')">
        <div class="cleartext" @click="searchOption.searchText='';getOrderList();"
             v-show="searchOption.searchText != ''">
          <i class="iconfont icon-cuowu"></i>
        </div>
      </div>
      <div class="searchBtn" @click="getOrderList">{{$t('search')}}</div>
    </div>
    <div class="orderList">
      <ul class="list clearfix">
        <li class="item" v-for="(order,index) in orderList.list" :key="order.rsvId" @click="linkDetail(order.rsvId)">
          <div class="detailed">
            <div class="top clearfix"><p class="left">{{$t('meetingBook_rsvName')}}：{{order.rsvName}}</p>
              <p class="right" style="color:#D0011B">{{$t('meetingBook_booking')}}</p></div>
            <div class="content clearfix">
              <ul class="clearfix">
                <li class="info row">
                  {{$t('meetingDetail_placeDes')}}: &nbsp;{{order.cateringPlaceDescript}}
                </li>
                <li class="info row">
                  {{$t('meetingOrder_dateBegin')}}: &nbsp;{{order.dateBegin}}
                </li>
                <li class="info row">
                  {{$t('meetingOrder_dateEnd')}}: &nbsp;{{order.dateEnd}}
                </li>
                <li class="info">
                  {{$t('meetingOrder_linkMan')}}: &nbsp;{{order.linkMan}}
                </li>
                <li class="info">
                  {{$t('meetingOrder_phone')}}: &nbsp;{{order.phone}}
                </li>
                <li class="info">
                  {{$t('meetingBook_rate')}}: &nbsp;{{order.rate}}
                </li>
                <li class="info">
                  {{$t('meetingBook_comRate')}}: &nbsp;{{order.comRate}}
                </li>
                <li class="info">
                  {{$t('meetingBook_remark')}}: &nbsp;{{order.remark}}
                </li>
              </ul>
              <i class="iconfont icon-you"></i>
            </div>
          </div>
        </li>
        <nothing :condition="orderList.list != null && orderList.list.length == 0"></nothing>
      </ul>
    </div>

  </div>
</template>
<script>
  import _ from 'lodash'
  import nothing from '../operaCommon/nothing'
  import {Toast} from 'mint-ui';

  export default {
    data() {
      return {
        tagindex: 1,
        orderList: {},
        searchOption: {
          currentPage: '1',
          pageSize: '100',
          searchText: '',

        },
      }
    },
    mounted() {
      this.getOrderList();
    },
    methods: {
      getOrderList() {
        this.$http.post('/mobilepmsapi/reception/cateringList', this.searchOption).then(res => {
          if (res.data.result == 0) {
            this.orderList = res.data.retVal;
            console.log(this.orderList)
          } else {
            if (res.data.msg.indexOf("Cannot connect to Hessian remote service") > 0) {
              this.msg(this.$t('meetingBook_not_support'));
            } else
              this.msg(res.data.msg);
          }
        })
      },
      msg(msg) {
        Toast({
          message: msg,
          position: 'bottom',
          duration: 3000
        });
      },
      getList(index) {
        this.tagindex = index;
        this.getOrderList();
      },
      linkDetail(id) {
        this.$router.push('/opera/meetingDetail/' + id);
      }
    },
    filters: {},
    components: {
      nothing
    },
    watch: {}
  }
</script>
<style lang='less' scoped>
  .opera-meeting {
    background: #f7f8fa;

    .ordertop {
      height: 1.28rem;
      width: 10rem;
      margin-top: 0.0533rem;
      background: #fff;
      padding: .18666667rem 0;
      box-sizing: border-box;

      .search {
        margin-left: .34666667rem;
        border-radius: .44rem;
        width: 7.92rem;
        float: left;
        height: .85333333rem;
        background-color: #f7f8fa;
        padding: 0 .26666667rem;
        overflow: hidden;
        box-sizing: border-box;

        i.icon-sousuo {
          vertical-align: bottom;
          font-size: 0.42666667rem;
          color: #ccc;
          line-height: .89333333rem;
        }

        input {
          padding-left: .2rem;
          width: 6rem;
          vertical-align: middle;
          margin-bottom: .13333rem;
          height: .62666667rem;
          background-color: #f7f8fa;
          outline: 0;
          border: 0;
        }

        .cleartext {
          float: right;
          display: block;

          i.icon-cuowu {
            line-height: 0.32rem;
            background-color: #c3c3c3;
            border-radius: 50%;
            font-size: 0.32rem;
            text-align: center;
            color: #fff;
            padding: 0.13333333rem;
            margin-top: 0.13333333rem;
            -webkit-transform-origin-x: 0;
            transform: scale(0.6);
            -webkit-transform: scale(0.6);
            width: 0.32rem;
            display: inline-block;
          }
        }
      }

      .searchBtn {
        width: 1.73333333rem;
        text-align: center;
        float: left;
        line-height: .85333333rem;
        font-size: .32rem;
        color: #333333;
      }
    }

    .orderList {
      margin-top: 0.1333rem;
      padding: 0 0.1333rem;
      /*.tags{
        background-color: #fff;
        .tag{
          float: left;
          position: relative;
          width: 25%;
          height: 34px;
          text-align: center;
          line-height: 34px;
          font-size: 12px;
          color: #333;
          &.active:after{
            content:'';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: 30px;
            height: 3px;
            background-color: #F69C2D;
            margin:0 auto;
          }
        }
      }*/

      .list {
        height: ~'calc(100vh - 2.72rem)';
        overflow: auto;
        width: 100%;

        .item {
          .detailed {
            width: 100%;
            margin: 12px auto 0;
            line-height: 14px;
            font-size: 12px;
            background-color: #fff;

            .top {
              padding: 6px 8px;
              border-bottom: 1px dashed #ddd;
              border-top: 3px solid #D2D6DE;

              .left {
                float: left;
              }

              .right {

                float: right;

                span {
                  color: #D0011B;
                }
              }
            }

            .content {
              position: relative;
              padding-left: 13px;

              .info {
                float: left;
                box-sizing: border-box;
                height: 22px;
                line-height: 22px;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .info:nth-of-type(2n-1) {
                width: 160px;
              }

              .info:nth-of-type(2n) {
                width: ~'calc(100% - 160px)';

              }

              .info.row {
                width: 100%;
              }

              .iconfont {
                position: absolute;
                right: 6px;
                top: ~'calc(50% - 6px)';
                color: #9b9b9b;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// meetingOrder.vue?373262a4